import axios from '@/api/axios';
import { mandatory } from '@/lib/helpers';

/**
 * Pay the order
 * @param {String} orderId - order identifier
 * @param {String} methodId - stripe card token
 * @param {String} intentId - stripe payment intent id
 * @returns {Promise}
 */
function orderPay({
  orderId = mandatory('orderId'),
  methodId,
  intentId,
}) {
  return axios.put(
    `orders/${orderId}/payment/`,
    { token: methodId, intent_id: intentId },
  );
}

/**
 * Get payment intent for order
 * @param {String} orderId - order identifier
 * @returns {Promise}
 */
function paymentIntent({
  orderId = mandatory('orderId'),
}) {
  return axios.post(
    `orders/${orderId}/payment_intent/`,
    {},
  );
}

/**
 * Capture the order
 * @param {String} orderId - order identifier
 * @param {String} intentId - stripe payment intent id
 * @returns {Promise}
 */
function capture({
  orderId = mandatory('orderId'),
  intentId,
}) {
  return axios.put(
    `orders/${orderId}/capture/`,
    { intent_id: intentId },
  );
}

/**
 * Create order
 * @returns {*|promise}
 */
function orderCreate(orderData) {
  return axios.post('orders/', orderData);
}

/**
 * Calc order.
 * @param {object} orderData
 * @returns {*|promise}
 */
function orderCalc(orderData) {
  return axios.post('orders/calc/', orderData);
}

/**
 * Update order
 * @returns {*|promise}
 */
function orderUpdate(orderId, orderData) {
  return axios.put(`orders/${orderId}/`, orderData);
}

/**
 * Patch order
 * @returns {*|promise}
 */
function orderPatch(orderId, orderData) {
  return axios.patch(`orders/${orderId}/`, orderData);
}

/**
 * Get orders for current user.
 * @returns {*}
 */
function orders() {
  return axios.get('orders/');
}

/**
 * Get order by uuid for current user.
 * @returns {*}
 */
function order(orderId) {
  return axios.get(`orders/${orderId}/`);
}

/**
 * Get terminal connect token.
 * @returns {*}
 */
function connectToken() {
  return axios.get('payments/connection_token/');
}

export default {
  orderPay,
  orderCreate,
  orderUpdate,
  connectToken,
  capture,
  orderPatch,
  orders,
  order,
  paymentIntent,
  orderCalc,
};



// WEBPACK FOOTER //
// ./src/apps/cart/api/index.js